module.exports = __webpack_public_path__ + "static/media/logoAlexaWeb.c51315a0.png";